import React, { useEffect, useState } from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import fallbackSubcatImg from "../assets/my-category.png";
import { getPublicRequest } from "../api/auth";
import API_ROUTES from "./config/apiConfig";
import "../styles/components.css";

export default function SubCategory({ slug, onNavigate }) {
  const [subCategories, setSubCategories] = useState([]);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (slug) {
      fetchSubCategories();
    }
  }, [slug]);


  const fetchSubCategories = async () => {
    try {
      setLoading(true);

      const res = await getPublicRequest(API_ROUTES.GET_CATEGORIES);

      const categories = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.data?.data)
          ? res.data.data
          : Array.isArray(res?.data?.items)
            ? res.data.items
            : [];

      const selectedCategory = categories.find(
        (item) => item.slug === slug
      );

      setCategory(selectedCategory || null);
      setSubCategories(selectedCategory?.children || []);

    } catch (err) {
      console.error("Failed to fetch subcategories:", err);

      setCategory(null);
      setSubCategories([]);

    } finally {
      setLoading(false);
    }
  };


  if (loading) {
    return <div className="container py-5 text-center text-white">Loading...</div>;
  }

  return (
    <div
      className="sub-category-universe py-5"
      style={{
        overflowX: "hidden",
        width: "100%"
      }}
    >
      <div
        className="container"
        style={{
          paddingLeft: "16px",
          paddingRight: "16px",
          boxSizing: "border-box"
        }}
      >
        {/* HEADER */}
        <div className="subcategory-header-block">
          <span className="editorial-eyebrow">
            <Sparkles size={14} style={{ marginRight: "6px" }} />
            Curated Collections
          </span>

          <h1 className="subcategory-main-title">
            {category?.name || "Sub-Categories"}
          </h1>

          <div className="fine-gold-line"></div>

          {category?.description && (
            <p className="subcategory-header-desc">{category.description}</p>
          )}
        </div>

        {/* SUB CATEGORY GRID */}
        {subCategories.length === 0 ? (
          <div className="empty-category-state">
            <p>No subcategories found for this collection.</p>
          </div>
        ) : (
          <div className="subcat-grid">
            {subCategories.map((sub) => (
              <div
                key={sub._id || sub.slug}
                className="subcat-card"
                onClick={() =>
                  onNavigate("subcategory", {
                    categorySlug: category.slug,
                    subCategorySlug: sub.slug,
                  })
                }

              >
                {/* 100% FIT IMAGE BOX (TAG REMOVED) */}
                <div className="subcat-image-container">
                  <img
                    src={sub.imageUrl || fallbackSubcatImg}
                    alt={sub.name}
                    loading="lazy"
                  />
                </div>

                {/* CONTENT */}
                <div className="subcat-card-info">
                  <h3 className="subcat-card-title">{sub.name}</h3>

                  {sub.description && (
                    <p className="subcat-card-description">{sub.description}</p>
                  )}

                  <div className="subcat-footer-anchor">
                    <span className="subcat-explore-link">
                      Explore Collection
                      <ArrowRight size={14} className="subcat-arrow-icon" />
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}